import { render } from "./Child-Ratio-Bar.vue?vue&type=template&id=c4edee36&scoped=true"
import script from "./Child-Ratio-Bar.vue?vue&type=script&lang=js"
export * from "./Child-Ratio-Bar.vue?vue&type=script&lang=js"

import "./Child-Ratio-Bar.vue?vue&type=style&index=0&id=c4edee36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4edee36"]])

export default __exports__